function handleTac() {
    const preventSubmitElements = document.querySelectorAll('[data-prevent-submit]');
    preventSubmitElements.forEach(element => {
        element.addEventListener('change', () => {
            const form = element.closest('form');
            if (form) {
                const submitButton = form.querySelector('button[type="submit"]');
                if (submitButton) {
                    submitButton.disabled = !element.checked;
                }
            }
        });
    });
}

export function initTac() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', handleTac);
    } else {
        handleTac();
    }
}

// Auto-init
initTac();
